import { useAxios } from 'shared/hooks/useAxios';
import { ICarsServiceProps } from 'shared/interfaces/ICars';
import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
const { GET } = useAxios();

export const carDao = () => {
  const getManufacturer = async (data: ICarsServiceProps['manufactureProps']) => {
    const response = await GET<ICarsServiceProps['manufacturerResponsePayload']>({
      url: `${ENDPOINTS.CARS_MANUFACTURER}?page=${data?.page}&limit=${data?.limit}`,
    });
    return response.data;
  };

  const getModel = async (data: ICarsServiceProps['modelProps']) => {
    const response = await GET<ICarsServiceProps['modelResponsePayload']>({
      url: `${ENDPOINTS.CARS_MODEL}/${data?.manufacturerId}?page=${data?.page}&limit=${data?.limit}`,
    });
    return response.data;
  };

  const getVariant = async (data: ICarsServiceProps['variantProps']) => {
    const response = await GET<ICarsServiceProps['variantResponsePayload']>({
      url: `${ENDPOINTS.CARS_VARIANT}/${data?.manufacturerId}/${data?.modelName}?page=${data?.page}&limit=${data?.limit}`,
    });
    return response.data;
  };
  const getSingleVariant = async (data: ICarsServiceProps['singleVariantProps']) => {
    const response = await GET<ICarsServiceProps['singleVariantResponsePayload']>({
      url: `${ENDPOINTS.CARS_SINGLE_VARIANT}/${data?.variantId}`,
    });
    return response.data;
  };

  return {
    getManufacturer,
    getModel,
    getVariant,
    getSingleVariant,
  };
};
